import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useSearchParams } from "@/lib/navigation";
import { useInternalUi } from "@/hooks/useInternalUi";

/** The new Settings sections are internal-only; anyone else lands on the same tab of today's Settings. */
export function InternalSettingsOnly({ section, children }: { section: "profile" | "notifications" | "integrations"; children: ReactNode }) {
  const internal = useInternalUi();
  const params = new URLSearchParams(useSearchParams());
  if (internal) return <>{children}</>;
  params.set("tab", section);
  return <Navigate to={`/settings?${params.toString()}`} replace />;
}
